var _g, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotFoundMessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8269_5945)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.7655 93.5938L77.828 72.6563C82.3593 67.1094 84.8593 60.125 84.8593 52.5C84.8593 34.5469 70.3077 20 52.3593 20C34.4108 20 19.9999 34.5516 19.9999 52.5C19.9999 70.4484 34.5499 85 52.3593 85C59.9827 85 66.9765 82.3578 72.5155 77.9625L93.453 98.9C94.328 99.6406 95.2968 100 96.2499 100C97.203 100 98.1687 99.6338 98.9015 98.9014C100.359 97.4375 100.359 95.0625 98.7655 93.5938ZM27.4999 52.5C27.4999 38.7156 38.7155 27.5 52.4999 27.5C66.2843 27.5 77.4999 38.7156 77.4999 52.5C77.4999 66.2844 66.2843 77.5 52.4999 77.5C38.7155 77.5 27.4999 66.2813 27.4999 52.5Z",
    fill: "#6B747D"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.0018 36.3C43.6401 36.3 40.1018 39.8384 40.1018 44.2C40.1018 46.0245 41.5773 47.5 43.4018 47.5C45.2263 47.5 46.7018 46.0245 46.7018 44.2C46.7018 43.4801 47.2819 42.9 48.0018 42.9H54.9737C56.9226 42.9 58.5018 44.4792 58.5018 46.4282C58.5018 47.8821 57.6071 49.189 56.2484 49.723L56.247 49.7236L51.7241 51.4825L51.7229 51.483C49.5683 52.3156 48.1518 54.3904 48.1518 56.6991V58C48.1518 59.8245 49.6273 61.3 51.4518 61.3C53.2763 61.3 54.7518 59.8245 54.7518 58V57.3832L58.6424 55.8702L58.6427 55.87C62.5338 54.3551 65.1018 50.6074 65.1018 46.4282C65.1018 40.8375 60.5644 36.3 54.9737 36.3H48.0018Z",
    fill: "#6B747D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4518 62.75C49.3111 62.75 47.5768 64.4843 47.5768 66.625C47.5768 68.7658 49.3111 70.5 51.4518 70.5C53.5925 70.5 55.3268 68.7658 55.3268 66.625C55.3268 64.4843 53.5925 62.75 51.4518 62.75Z",
    fill: "#6B747D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8269_5945"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white",
    transform: "translate(20.0001 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFoundMessage);
export default __webpack_public_path__ + "static/media/notFoundMessage.84ed8500acb64bb3b948574af4e5cc3b.svg";
export { ForwardRef as ReactComponent };